import request from "@/utils/request";


function spreadAnalysisGetSpreadTop10(data){   // 七天传播排行榜
    return request({
        url: "/spreadAnalysis/getSpreadTop10",
        method: "post",
        data
    })
}

function spreadAnalysisGetSpreadTrend(data){   //传播趋势图
    return request({
        url: "/spreadAnalysis/getSpreadTrend",
        method: "post",
        data
    })
}

function spreadAnalysisGetSpreadSearch(data){     //事件搜索
    return request({
        url: "/spreadAnalysis/getSpreadSearch",
        method: "post",
        data
    })
}
function spreadAnalysisGetSpreadAnalysisDetail(data){   //事件分析详情
    return request({
        url: "/spreadAnalysis/getSpreadAnalysisDetail",
        method: "post",
        data
    })
}
export {
    spreadAnalysisGetSpreadTop10,
    spreadAnalysisGetSpreadTrend,
    spreadAnalysisGetSpreadSearch,
    spreadAnalysisGetSpreadAnalysisDetail
}
